import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgSelectConfig} from '@ng-select/ng-select';
import {AuthenticationService} from './services/auth/authentication.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {LocalStorage} from './utils/storage';
import {Utils} from './utils.class';
import {Settings} from './settings/settings';
import * as appVersion from '../compiled-version';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {User} from './classes/user';
import {Routenames} from './routenames';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'tsned';

    private subscriptions = new Subscription();
    env = environment;

    parentUser: User;
    user: User;

    constructor(private authenticationService: AuthenticationService,
                private http: HttpClient,
                private router: Router,
                private ngSelectConfig: NgSelectConfig) {
        window.addEventListener('focus', () => {
            this.http.get<{ buildNumber: string }>('/assets/version.json?v=' + (new Date()).getTime()).subscribe(version => {
                setTimeout(() => {
                    Settings.versionUpdateAvailable = version.buildNumber !== appVersion.compiledVersion.buildNumber;
                });
            });
        });

        this.ngSelectConfig.notFoundText = 'Geen items gevonden';
        this.ngSelectConfig.typeToSearchText = 'Typ om te zoeken';
        this.ngSelectConfig.loadingText = 'Aan het laden...';
        this.ngSelectConfig.clearAllText = 'Verwijder alles';
        this.ngSelectConfig.addTagText = 'Voeg item toe';
    }

    ngOnInit() {
        if (LocalStorage.userToken) {
            const expiryDate = new Date(Utils.getJwtData(LocalStorage.userToken).exp * 1000);
            const refreshIfAfter = new Date();
            if (expiryDate <= refreshIfAfter) {
                this.subscriptions.add(this.authenticationService.refresh().subscribe(() => {
                    this.loadCurrentUserAndStartNavigation();
                }, () => {
                    this.router.initialNavigation();
                }));
            } else {
                this.loadCurrentUserAndStartNavigation();
            }
        } else {
            this.router.initialNavigation();
        }

        this.subscriptions.add(this.authenticationService.loggedIn.subscribe(loggedIn => {
            if (loggedIn) {
                this.parentUser = LocalStorage.parentUser;
                this.user = LocalStorage.user;
            }
        }));
        this.parentUser = LocalStorage.parentUser;
        this.user = LocalStorage.user;
    }

    backToParentUser() {
        this.router.navigateByUrl(`/${Routenames.Logout}`);
    }

    private loadCurrentUserAndStartNavigation() {
        this.subscriptions.add(this.authenticationService.getCurrentUser().subscribe(() => {
            this.router.initialNavigation();
        }));
        this.authenticationService.refreshTokenIfNeeded();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
